// --- CONFIG ---
// High-level controls for the marquee (newsletter), header, and footer.
var IMAGE_URL = 'https://cdn.shopify.com/s/files/1/0695/2399/6810/files/music-for-pleasure-cometa-1.png?v=1785270341';
var TILE_SCALE = 0.4;       // size multiplier for each tile
var GAP_X = 1.1;            // horizontal spacing multiplier (1 = no gap)
var GAP_Y = 2;            // vertical spacing multiplier
var SCROLL_SPEED = 0.5;     // pixels per frame
var ANGLE = 45;             // degrees (negative = opposite direction)
var ROW_OFFSET = 250;         // stagger rows by this many px (0 = grid, try half colWidth for diamond)
var MARQUEE_ENABLED = true;                       // false to hide the marquee tiles
var MARQUEE_HIDE_HOME = true;                    // true to hide the marquee tiles on the home page
var MARQUEE_DISABLE_PRODUCT_PAGES = true;        // auto-disable marquee on /products/*
var MARQUEE_FEATHER = false;   // smooth fade at edges of the marquee
var HEADER_TRANSPARENT_PAGES = ['*'];  // pages where the header animates on scroll — use URL paths like '/shop' or '*' for all
var HEADER_TRANSPARENT_EXCLUDE = ['/pages/faq','/pages/warranty','/policies/privacy-policy'];  // pages where the header stays transparent while animating (no solid background) — supports '*' and '/*'
var FOOTER_TRANSPARENT_PAGES = ['/', '/home', '/products/*'];  // pages where footer is transparent — supports '*' and '/*'
var MOBILE_HIDE_NEWSLETTER_PAGES = ['/'];  // hide newsletter entirely on mobile for these pages — supports '*' and '/*'
// --- END CONFIG ---

function matchPath(p) {
  if (p === '*') return true;
  if (p.endsWith('/*')) return window.location.pathname.startsWith(p.slice(0, -1));
  return window.location.pathname === p || window.location.pathname === p + '/';
}

document.querySelectorAll('.newsletter__marquee').forEach(function (canvas) {
  canvas.dataset.feather = MARQUEE_FEATHER;
  var ctx = canvas.getContext('2d');
  var img = new Image();
  img.crossOrigin = 'anonymous';
  img.src = IMAGE_URL;

  var rad = (ANGLE * Math.PI) / 180;
  var offset = 0;
  var imgW, imgH, colWidth, rowHeight;
  var ready = false;
  var lastTime = 0;
  var hideOnHome = MARQUEE_HIDE_HOME && matchPath('/');
  var active = MARQUEE_ENABLED && !hideOnHome && !(MARQUEE_DISABLE_PRODUCT_PAGES && window.location.pathname.startsWith('/products'));
  if (!active) canvas.closest('.newsletter')?.classList.add('newsletter--disabled');
  if (MOBILE_HIDE_NEWSLETTER_PAGES.some(matchPath)) canvas.closest('.newsletter')?.classList.add('newsletter--hide-mobile');

  img.onload = function () {
    imgW = img.width * TILE_SCALE;
    imgH = img.height * TILE_SCALE;
    colWidth = imgW * GAP_X;
    rowHeight = imgH * GAP_Y;
    ready = true;
    resize();
    lastTime = 0;
    requestAnimationFrame(draw);
  };

  function resize() {
    canvas.width = canvas.clientWidth * window.devicePixelRatio;
    canvas.height = canvas.clientHeight * window.devicePixelRatio;
  }

  function draw(timestamp) {
    var w = canvas.clientWidth;
    var h = canvas.clientHeight;
    if (w <= 0 || h <= 0 || !ready) {
      requestAnimationFrame(draw);
      return;
    }

    if (!lastTime) lastTime = timestamp;
    var dt = Math.min(timestamp - lastTime, 100) / 16.667;
    lastTime = timestamp;

    ctx.setTransform(1, 0, 0, 1, 0, 0);
    ctx.scale(window.devicePixelRatio, window.devicePixelRatio);
    ctx.clearRect(0, 0, w, h);

    ctx.save();
    ctx.translate(w / 2, h / 2);
    ctx.rotate(rad);

    if (!active) {
      ctx.restore();
      requestAnimationFrame(draw);
      return;
    }

    offset = offset + SCROLL_SPEED * dt;

    var diag = Math.sqrt(w * w + h * h);
    var halfDiag = diag / 2;
    var minCol = Math.floor((-halfDiag - offset) / colWidth) - 1;
    var maxCol = Math.ceil((halfDiag - offset) / colWidth) + 1;
    var minRow = Math.ceil(-halfDiag / rowHeight) - 1;
    var maxRow = Math.ceil(halfDiag / rowHeight) + 1;

    for (var row = minRow; row < maxRow; row++) {
      var rowShift = (row % 2) * ROW_OFFSET;
      for (var col = minCol; col < maxCol; col++) {
        ctx.drawImage(img, col * colWidth + offset + rowShift, row * rowHeight, imgW, imgH);
      }
    }

    ctx.restore();
    requestAnimationFrame(draw);
  }

  resize();
  if (img.complete && img.naturalWidth > 0) {
    imgW = img.naturalWidth * TILE_SCALE;
    imgH = img.naturalHeight * TILE_SCALE;
    colWidth = imgW * GAP_X;
    rowHeight = imgH * GAP_Y;
    ready = true;
    lastTime = 0;
    requestAnimationFrame(draw);
  }

  window.addEventListener('resize', resize);
});

(function() {
  var bannerMedia = document.querySelector('body.template-index .banner__media.animate--fixed');
  var newsletters = document.querySelectorAll('.newsletter');
  if (!bannerMedia || !newsletters.length) return;

  var observer = new IntersectionObserver(function(entries) {
    var show = false;
    entries.forEach(function(e) { if (e.isIntersecting) show = true; });
    bannerMedia.classList.toggle('is-visible', show);
  }, { rootMargin: '400px 0px' });

  newsletters.forEach(function(el) { observer.observe(el); });
})();

(function() {
  var header = document.querySelector('.header-wrapper');
  if (!header) return;

  var matchPage = HEADER_TRANSPARENT_PAGES.some(matchPath);
  var transparent = HEADER_TRANSPARENT_EXCLUDE.some(matchPath);
  if (!matchPage) return;

  var isExplore = document.body.classList.contains('Explore');
  var headerLogo = isExplore ? header.querySelector('.header__heading-logo-wrapper') : null;

  // var threshold = header.offsetHeight;
  var threshold = 0;
  var lastY = 0;
  var offset = 0;

  function updateHeader() {
    var hh = header.offsetHeight;
    var sy = window.scrollY;
    var delta = sy - lastY;

    if (sy <= threshold) {
      offset = 0;
    } else if (delta > 0) {
      offset = Math.min(offset + delta, hh);
    } else if (delta < 0) {
      offset = Math.max(offset + delta, 0);
    }

    header.style.transform = 'translateY(' + (-offset) + 'px)';

    var dark = sy > hh && !transparent;
    header.classList.toggle('header-wrapper-dark', dark);
    if (headerLogo) {
      headerLogo.classList.toggle('header-logo-hidden', !dark);
    }

    lastY = sy;
  }

  window.addEventListener('scroll', function() { requestAnimationFrame(updateHeader); }, { passive: true });
  updateHeader();
})();

(function() {
  var footer = document.querySelector('.footer');
  if (!footer) return;

  var matchFooter = FOOTER_TRANSPARENT_PAGES.some(matchPath);
  footer.classList.toggle('footer-transparent', matchFooter);
  if (!matchFooter) footer.classList.add('footer-black');
})();
